import React, {useState, useEffect} from "react";

interface CollapsibleSectionProps {
  title: string;
  id?: string;
  children: React.ReactNode;
}

const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  id,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  // If there's a hash in the URL and it matches the ID, open the section
  useEffect(() => {
    if (id && window.location.hash === `#${id}`) {
      setIsOpen(true);
    }
  }, [id]);

  return (
    <div className="collapsible-section" id={id}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="collapsible-header"
        aria-expanded={isOpen}
      >
        <h4>{title}</h4>
        <span className={`chevron ${isOpen ? "open" : ""}`}>▼</span>
      </button>
      {isOpen && (
        <div className="collapsible-content">
          <div style={{paddingTop: "24px"}}>{children}</div>
        </div>
      )}
    </div>
  );
};

export default CollapsibleSection;
